import { css } from '@emotion/react';
import { wplToken } from '@atlassiansox/wpl-token';
import { getColor, getMediaDown, getMediaUp } from '@atlassiansox/wpl-utils';

const containerStyle = css`
  display: flex;
  align-items: center;
  align-self: stretch;
  cursor: pointer;
`;

const frameStyle = css`
  border-radius: ${wplToken('space.025')};
  box-shadow: 0px 0px 1px 0px ${getColor('n900')} 31%,
    0px 3px 5px 0px ${getColor('n900')} 20%;
`;

const familyNameStyle = css`
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: var(--bxp-charlie-text-font-family);
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.625rem;
`;

export const modalStyle = css`
  position: absolute;
  right: 0;
  background-color: ${getColor('n0')};
  ${containerStyle};
  flex-direction: column;
  justify-content: center;
  border: 1px solid #ccc;
  ${frameStyle};
  padding: 0px;
  border-radius: 4px;
  box-shadow: 0px 3px 5px 0px #091e4233;

  ${getMediaDown('md')} {
    top: 130%;
  }

  ${getMediaUp('md')} {
    bottom: 130%;
  }
`;

export const productCellStyle = css`
  ${containerStyle};
  padding: ${wplToken('space.100')} ${wplToken('space.200')};
  color: #000;
  ${familyNameStyle};
  padding-right: ${wplToken('space.800')};
  white-space: nowrap;

  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background-color: ${getColor('n20')};
  }
  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${getColor('n20')};
  }
  ${getMediaDown('md')} {
    height: ${wplToken('space.500')};
    padding: 0 ${wplToken('space.050')} 0 ${wplToken('space.250')};
    padding-right: ${wplToken('space.300')};
    font-size: 1rem;
    border-bottom: ${wplToken('space.025')} solid #ccc;
    line-height: normal;
  }
`;
